interface SectionLabelProps {
  children: React.ReactNode;
}

export function SectionLabel({ children }: SectionLabelProps) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <div className="w-3 h-px bg-action" />
      <span className="font-mono text-xs uppercase tracking-widest text-action">
        {children}
      </span>
    </div>
  );
}
